import { AsyncPipe, NgClass } from '@angular/common';
import { Component, OnInit, ViewEncapsulation, inject, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { MenuGroup } from '../../../../_common/model/menu-group';
import { MenuService } from '../../../../_common/services/menu.service';

@Component({
    selector: 'lay-men-menu',
    templateUrl: './lay-men-menu.component.html',
    styleUrls: ['./lay-men-menu.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [RouterLinkActive, RouterLink, NgbTooltip, NgClass, AsyncPipe],
})
export class LayMenMenuComponent implements OnInit {
    private menu = inject(MenuService);

    public readonly isMin = input(false);

    public menuGroup: Observable<MenuGroup[]>;

    ngOnInit() {
        this.menuGroup = this.menu.mainMenu$;
    }
}
